<div class="diag-container">
    <!-- Initial Animation Screen -->
  
    <div class="animation-screen" *ngIf="showInitialAnimation">
      <div class="animation-content">
        <div class="electrical-animation">
          <div class="circuit-board">
            <div class="circuit-line line-1"></div>
            <div class="circuit-line line-2"></div>
            <div class="circuit-line line-3"></div>
            <div class="circuit-line line-4"></div>
            <div class="circuit-node node-1"></div>
            <div class="circuit-node node-2"></div>
            <div class="circuit-node node-3"></div>
            <div class="circuit-node node-4"></div>
            <div class="circuit-node node-5"></div>
          </div>
          <div class="sensor-icon-container">
            <mat-icon class="pulse">sensors</mat-icon>
          </div>
          <div class="scanning-wave"></div>
        </div>
        <h2>System Diagnostics</h2>
        <p class="animation-message">{{ animationMessage }}</p>
        <div class="progress-container">
          <div class="progress-fill" [style.width.%]="animationProgress"></div>
        </div>
        <div class="progress-text">{{ animationProgress }}%</div>
        <div class="device-count">Analyzing device(s)...</div>
      </div>
    </div>
    <!-- Header -->
    <div class="diag-header">
      <div class="header-content">
        <div class="header-icon">
          <mat-icon>memory</mat-icon>
        </div>
        <div class="header-text">
          <h2>Sensor Diagnostics</h2>
          <div class="device-id" *ngIf="showSummary">{{ devices.length }} Device(s)</div>
          <div class="device-id" *ngIf="!showSummary && selectedDevice">{{ selectedDevice.deviceId }}</div>
        </div>
      </div>
      <div class="header-actions">
        <button mat-icon-button class="action-btn pdf-btn" *ngIf="showSummary && getTotalFailedDevices() > 0"
          (click)="downloadPDFReport()" matTooltip="Download PDF Report" matTooltipPosition="below">
          <mat-icon>picture_as_pdf</mat-icon>
        </button>
       
      </div>
    </div>
  
    <!-- Back Button (when viewing device details) -->
    <div class="back-section" *ngIf="!showSummary">
      <button mat-button class="back-btn" (click)="backToSummary()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Summary</span>
      </button>
    </div>
  
    <!-- SUMMARY VIEW: Show all devices -->
    <div class="summary-view" *ngIf="showSummary && !loading">
      <!-- Search Section -->
      <div class="search-section">
        <div class="search-box">
          <mat-icon class="search-icon">search</mat-icon>
          <input type="text" class="search-input" placeholder="Search by Device ID..." [(ngModel)]="searchText"
            (input)="onSearchChange()" />
          <button mat-icon-button class="clear-btn" *ngIf="searchText" (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="search-results-info" *ngIf="searchText">
          <span>Found {{ filteredDevices.length }} device(s)</span>
        </div>
      </div>
  
      <!-- Overall Statistics -->
      <div class="overall-stats">
        <div class="stat-card total" [class.active]="activeFilter === 'all'" (click)="filterByStatus('all')">
          <mat-icon>devices</mat-icon>
          <div class="stat-info">
            <div class="stat-value">{{ getTotal() }}</div>
            <div class="stat-label">Total Devices</div>
          </div>
        </div>
        <div class="stat-card total" [class.active]="activeFilter === 'all'" (click)="filterByStatus('offlline')">
          <mat-icon>cloud_off</mat-icon> 
          <div class="stat-info">
            <div class="stat-value">{{ getofflineWorkingDevices() }}</div>
            <div class="stat-label">Offline: Not Installed / No Comms</div>
          </div>
        </div>
        <div class="stat-card success" [class.active]="activeFilter === 'healthy'" (click)="filterByStatus('healthy')">
          <mat-icon>check_circle</mat-icon>
          <div class="stat-info">
            <div class="stat-value">{{ getTotalWorkingDevices() }}</div>
            <div class="stat-label">Healthy</div>
          </div>
        </div>
        <div class="stat-card error" [class.active]="activeFilter === 'issues'" (click)="filterByStatus('issues')">
          <mat-icon>error</mat-icon>
          <div class="stat-info">
            <div class="stat-value">{{ getTotalFailedDevices() }}</div>
            <div class="stat-label">With Issues</div>
          </div>
        </div>
      </div>
  
      <!-- Failed Sensors Summary -->
      <div class="failed-sensors-summary" *ngIf="getTotalFailedDevices() > 0 && devices.length > 0">
        <h3>Failed Sensors Overview</h3>
        <div class="sensor-type-grid">
          <div class="sensor-type-card" *ngFor="let sensor of getFailedSensorsByType() | keyvalue"
            [class.active]="activeFilter === sensor.key" (click)="filterBySensorType(sensor.key)">
            <div class="sensor-type-icon">
              <mat-icon>error_outline</mat-icon>
            </div>
            <div class="sensor-type-info">
              <div class="sensor-type-name">{{ sensor.key }}</div>
              <div class="sensor-type-count">{{ sensor.value }} device(s) affected</div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Device List -->
      <div class="devices-list">
        <div class="list-header">
          <h3>Devices</h3>
          <div class="filter-info">
            <div class="filter-badge" *ngIf="searchText">
              <mat-icon>search</mat-icon>
              <span>Search: "{{ searchText }}"</span>
            </div>
            <div class="filter-badge active-filter" *ngIf="activeFilter !== 'all'">
              <mat-icon>filter_alt</mat-icon>
              <span *ngIf="activeFilter === 'healthy'">Healthy Devices</span>
              <span *ngIf="activeFilter === 'issues'">Devices with Issues</span>
              <span *ngIf="activeFilter !== 'healthy' && activeFilter !== 'issues'">{{ activeFilter }}</span>
            </div>
            <button mat-icon-button class="clear-filter-btn" *ngIf="activeFilter !== 'all' || searchText"
              (click)="clearAllFilters()" matTooltip="Clear all filters">
              <mat-icon>clear_all</mat-icon>
            </button>
          </div>
        </div>
        <div class="results-count" *ngIf="filteredDevices.length > 0">
          Showing {{ filteredDevices.length }} of {{ devices.length }} device(s)
        </div>
        <div class="no-results" *ngIf="filteredDevices.length === 0">
          <mat-icon>search_off</mat-icon>
          <p *ngIf="searchText">No devices found matching "{{ searchText }}"</p>
          <p *ngIf="!searchText && activeFilter !== 'all'">No devices match the selected filter</p>
          <button mat-raised-button color="primary" (click)="clearAllFilters()">Clear Filters</button>
        </div>
        <div class="device-card" *ngFor="let device of filteredDevices"
          [ngClass]="{ 'has-issues': device.failedCount > 0, 'healthy': device.failedCount === 0 }"
          (click)="viewDeviceDetails(device)">
  
          <div class="device-card-header">
            <div class="device-info">
              <mat-icon class="device-icon">router</mat-icon>
              <div class="device-details">
                <div class="device-name"> {{ device.deviceId }} - {{ device.siteName }} </div>
                <div class="device-status">
                  <span class="status-text" [ngClass]="device.failedCount > 0 ? 'error' : 'success'">
                    {{ device.failedCount > 0 ? device.failedCount + ' Issues' : 'All Sensors OK' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="device-actions">
              <mat-icon>chevron_right</mat-icon>
            </div>
          </div>
  
  
          <div class="mini-stat success">
            <mat-icon>check_circle</mat-icon>
            <span>{{ device.workingCount }} OK</span>
          </div>
          <div class="mini-stat error" *ngIf="device.failedCount > 0">
            <mat-icon>cancel</mat-icon>
            <span>{{ device.failedCount }} Failed</span>
          </div>
          <div class="mini-stat total">
            <mat-icon>sensors</mat-icon>
            <span>{{ device.sensorStatus.length }} Total</span>
          </div>
  
  
          <!-- Show failed sensor names -->
          <div class="sensors-list" *ngIf="device.sensorStatus.length > 0">
            <div class="sensor-tag" *ngFor="let sensor of device.sensorStatus"
              [ngClass]="sensor.status === 'fail' ? 'failed' : 'working'">
              <mat-icon>{{ sensor.icon }}</mat-icon>
              <span>{{ sensor.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- DETAIL VIEW: Show selected device sensors -->
    <div class="detail-view" *ngIf="!showSummary && selectedDevice && !loading">
      <!-- Scanning Progress -->
      <div class="progress-section" *ngIf="scanning">
        <div class="progress-info">
          <div class="scanning-text">
            <mat-icon class="spin">settings</mat-icon>
            <span>Checking sensors...</span>
          </div>
          <span class="progress-percent">{{ progress }}%</span>
        </div>
        <div class="progress-bar-container">
          <div class="progress-bar" [style.width.%]="progress"></div>
        </div>
      </div>
  
      <!-- Summary Stats (only after scan completes) -->
      <div class="stats-row" *ngIf="!scanning && selectedDevice.visibleSensors.length > 0">
        <div class="stat-card success">
          <mat-icon>check_circle</mat-icon>
          <div class="stat-info">
            <div class="stat-value">{{ getWorkingCount() }}</div>
            <div class="stat-label">Working</div>
          </div>
        </div>
        <div class="stat-card error">
          <mat-icon>error</mat-icon>
          <div class="stat-info">
            <div class="stat-value"></div>
            <div class="stat-label">Issues</div>
          </div>
        </div>
        <div class="stat-card total">
          <mat-icon>sensors</mat-icon>
          <div class="stat-info">
            <div class="stat-value">{{ selectedDevice.visibleSensors.length }}</div>
            <div class="stat-label">Total</div>
          </div>
        </div>
      </div>
  
      <!-- Sensor Grid (show all with blur effect) -->
      <div class="sensors-section">
        <div class="sensor-grid">
          <!-- Show all sensors from sensorStatus array -->
          <div class="sensor-card" *ngFor="let s of selectedDevice.sensorStatus; let i = index"
            [ngClass]="getSensorClass(i)" (click)="onSensorClick(s)">
  
            <!-- Show checking state -->
            <div class="checking-state" *ngIf="isChecking(i)">
              <mat-icon class="spin">sync</mat-icon>
              <div class="sensor-name">{{ s.name }}</div>
              <div class="checking-msg">Checking...</div>
            </div>
  
            <!-- Show result state -->
            <div class="result-state" *ngIf="isCompleted(i)">
              <div class="sensor-header">
                <div class="sensor-icon-wrapper">
                  <mat-icon class="sensor-icon">{{ s.icon }}</mat-icon>
                </div>
                <div class="status-badge" [ngClass]="getCompletedSensor(i)?.statusClass">
                  <mat-icon>{{ getCompletedSensor(i)?.statusIcon }}</mat-icon>
                </div>
              </div>
              <div class="sensor-body">
                <div class="sensor-name">{{ s.name }}</div>
                <div class="sensor-message">{{ getCompletedSensor(i)?.message }}</div>
                <div class="sensor-fail-value"
                  *ngIf="getCompletedSensor(i)?.failValue && getCompletedSensor(i)?.status === 'fail'">
                  <small>{{ getCompletedSensor(i)?.failValue }}</small>
                </div>
              </div>
            </div>
  
            <!-- Show blurred placeholder for pending -->
            <div class="pending-state" *ngIf="isPending(i)">
              <div class="sensor-header">
                <div class="sensor-icon-wrapper">
                  <mat-icon class="sensor-icon">{{ s.icon }}</mat-icon>
                </div>
                <div class="status-placeholder"></div>
              </div>
              <div class="sensor-body">
                <div class="sensor-name">{{ s.name }}</div>
                <div class="sensor-message">Waiting...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Loading State -->
    <div class="loading-state" *ngIf="loading">
      <mat-icon class="spin">refresh</mat-icon>
      <p>Loading device data...</p>
    </div>
  </div>